import React from 'react'
import { Text } from './styles'

interface ILabelProps {
  text: string
  isActive: boolean
}

export const Label = ({ text, isActive }: ILabelProps): JSX.Element => <Text isActive={isActive}>{text}</Text>

interface ITimelineLabelProps {
  isActive: boolean
  children: string
}

export const MotherTimelineLabel = ({ isActive, children }: ITimelineLabelProps): JSX.Element => (
  <Label text={children} isActive={isActive} />
)

interface IBabyTimelineLabelProps extends ITimelineLabelProps {}

export const BabyTimelineLabel = ({ isActive, children }: IBabyTimelineLabelProps): JSX.Element => {
  return <Label text={children} isActive={isActive} />
}
